<template>
    <div class="activity-item-gallery" v-if="review.gallery.length">
      <span class="cursor-pointer" v-for="(image, index) in review.gallery" :key="`review-image-${image.id}`">
          <img :src="image.thumb" @click="openImage(image, index)" :alt="image.caption ? image.caption : 'Photo by ' + review.user.full_name" v-rjs="2"/>
      </span>
    </div>
</template>
<script>
export default {

    props:['review'],

    methods:{
        openImage(image, index){
            eventBus.$emit('display-media-image', {
                review: this.review,
                index: index,
            })
        }
    },
}
</script>
